module.exports = __webpack_public_path__ + "static/etecube-website-mainPage-1-6602b3d6e4a6958b589159415d946be6.png";